import styles from '../Disco.module.css';
import { useTheme } from '../../../../../../hooks/useTheme';
import Button from '../../../../../ui/Button/BlockButton';
import { AdContent } from './AdContent';
import { PILL_BUTTON_STYLE } from './BannerOffer';
import type { DiscoOffer } from '../types';

interface EddOfferCardProps {
  heading: string;
  subheading: string;
  disclosureDetails?: DiscoOffer['disclosure_details'];
  jsonContent?: unknown;
  advertiserLogoUrl?: string;
  acceptCopy: string;
  declineCopy: string;
  onAccept: () => void;
  onDecline: () => void;
  currentIndex: number;
  totalCount: number;
  widgetRef: React.RefCallback<HTMLDivElement>;
  adRef: React.RefCallback<HTMLDivElement>;
}

export function EddOfferCard({
  heading,
  subheading,
  disclosureDetails,
  jsonContent,
  advertiserLogoUrl,
  acceptCopy,
  declineCopy,
  onAccept,
  onDecline,
  currentIndex,
  totalCount,
  widgetRef,
  adRef,
}: EddOfferCardProps) {
  const theme = useTheme();
  const fontFamily = theme.bodytextDefaultNone?.fontFamily;

  return (
    <div
      ref={widgetRef}
      data-testid="edd-offer-card"
      className={styles.eddOffer}
      style={{ fontFamily }}
    >
      <div ref={adRef} className={styles.eddOfferContent}>
        <div className={styles.eddOfferTop}>
          <div className={styles.eddOfferTitleBlock}>
            <span className={styles.sponsoredBadge}>Sponsored</span>
            <h2
              className={styles.eddOfferHeading}
              style={{ fontFamily: theme.headersMediumNone?.fontFamily }}
            >
              {heading}
            </h2>
          </div>
          {advertiserLogoUrl && (
            <div className={styles.eddOfferLogo}>
              <img src={advertiserLogoUrl} alt="" />
            </div>
          )}
        </div>
        <div className={styles.eddOfferBody}>
          <AdContent
            subheading={subheading}
            disclosureDetails={disclosureDetails}
            jsonContent={jsonContent}
            bodyStyle={{ fontFamily }}
          />
        </div>
      </div>
      <div className={styles.eddOfferActions}>
        <Button big onClick={onAccept} style={PILL_BUTTON_STYLE}>
          {acceptCopy}
        </Button>
        <button
          type="button"
          className={styles.eddOfferDecline}
          style={{ fontFamily }}
          onClick={onDecline}
        >
          {declineCopy}
        </button>
        <span className={styles.eddOfferCounter}>
          {currentIndex}/{totalCount}
        </span>
      </div>
    </div>
  );
}
